/* eslint-disable vue/no-use-v-if-with-v-for */
<template>
  <div class="container-fluid">
    <page-title
      :canDownload="false"
      :title="this.$t('users')"
      iconClasses="fas fa-users"
      :tooltipLabel="$t('user.add')"
      v-on:onButtonClick="fillEditModal(-1)"
      :isTimelineDisplayed="false"
      :hasModal="true"
      :isDataLoading="!downloaded"
      :modalId="'#editUserModal'"
    />

    <div class="container-fluid">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">ID</th>
            <th scope="col">{{ $t('email') }}</th>
            <th scope="col">{{ $t('role') }}</th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, index) in users" :key="user.id">
            <th scope="row">{{ user.id }}</th>
            <td>{{ user.email }}</td>
            <td>{{ $t('user.' + user.role.toLowerCase()) }}</td>
            <td>
              <button
                type="button"
                class="btn btn-chart"
                data-toggle="modal"
                data-target="#editUserModal"
                @click="fillEditModal(index)"
              >
                <i class="fas fa-pen"></i>
              </button>
            </td>
            <td>
              <button
                type="button"
                class="btn btn-danger"
                data-toggle="modal"
                data-target="#confirmDeleteUserModal"
                @click="setIndexToDelete(index)"
              >
                <i class="fas fa-trash-alt"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal use to add or edit an user -->
    <div
      class="modal fade"
      id="editUserModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editUserModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editUserModalLabel" v-if="selectedIndex >= 0">
              {{ $t('user.edit') }}
            </h5>
            <h5 class="modal-title" id="editUserModalLabel" v-if="selectedIndex < 0">
              {{ $t('user.add') }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <label for="email-input" class="col-form-label col-sm-3">{{ $t('email') }} :</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  id="email-input"
                  v-model="editUserForm.email"
                  :placeholder="$t('user.email_placeholder')"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="role-input" class="col-form-label col-sm-3">{{ $t('role') }} :</label>
              <div class="col-sm-9">
                <select class="form-control" id="role-input" v-model="editUserForm.role_id">
                  <option v-for="role in availablesRoles" :key="role.id" :value="role.id">{{
                    $t(`user.${role.name}`)
                  }}</option>
                </select>
              </div>
            </div>
            <div class="form-group row" v-if="selectedRole && selectedRole.name === 'partner'">
              <label for="site-input" class="col-form-label col-sm-3">{{ $t('sites') }} :</label>
              <div class="col-sm-9">
                <select class="form-control" id="site-input" v-model="editUserForm.sites" multiple>
                  <option v-for="site in sites" :value="site" :key="site">
                    {{ getLocalizedSiteName(site) }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row" v-if="selectedRole && selectedRole.name === 'partner'">
              <label for="auth-type-input" class="col-form-label col-sm-3"
                >{{ $t('auth_type') }} :</label
              >
              <div class="col-sm-9">
                <select class="form-control" id="auth-type-input" v-model="editUserForm.authType">
                  <option value="google">{{ $t('user.google') }}</option>
                  <option value="custom">{{ $t('user.custom') }}</option>
                </select>
              </div>
            </div>
            <div
              class="form-group row"
              v-if="
                editUserForm.authType === 'custom' &&
                  selectedRole &&
                  selectedRole.name === 'partner'
              "
            >
              <div class="col-sm-12">
                <input
                  v-model="editUserForm.password"
                  type="password"
                  id="password-input"
                  class="form-control"
                  :placeholder="$t('login.password')"
                  required
                />
              </div>
            </div>
            <div
              class="form-group row"
              v-if="
                editUserForm.authType === 'custom' &&
                  selectedRole &&
                  selectedRole.name === 'partner'
              "
            >
              <div class="col-sm-12">
                <input
                  v-model="editUserForm.confirmPassword"
                  type="password"
                  id="confirm-password-input"
                  class="form-control"
                  :placeholder="$t('login.password_confirmation')"
                  required
                />
              </div>
            </div>
            <div class="row justify-content-md-center" v-if="editUserForm.id > 0">
              <button type="button" class="btn btn-secondary btn-sm" @click="getUserAccessToken()">
                <i class="fas fa-key"></i>
              </button>
            </div>
            <div
              class="row justify-content-md-center mt-1"
              v-if="editUserForm.id > 0 && editUserForm.access_token != ''"
            >
              <div class="col">
                <input
                  type="text"
                  for="site-input"
                  class="form-control"
                  :value="editUserForm.access_token"
                  :placeholder="$t('api_key')"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              {{ $t('cancel') }}
            </button>
            <button
              type="button"
              v-if="!isFormValid"
              class="btn btn-primary disabled"
              v-tooltip="{ content: $t('user.password_mismatch'), placement: 'top-center' }"
            >
              {{ editUserForm.email == '' ? $t('add') : $t('save') }}
            </button>
            <button
              type="button"
              v-if="isFormValid"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="onUpdateUser"
            >
              {{ editUserForm.email == '' ? $t('add') : $t('save') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal use to confirm user suppression -->
    <div
      class="modal fade"
      id="confirmDeleteUserModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="confirmDeleteUserModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="confirmDeleteUserModalLabel"
              v-if="selectedIndex >= 0 && users[selectedIndex]"
            >
              {{ $t('modal.confirm_user_delete', [users[selectedIndex].email]) }}
            </h5>
            <h5 class="modal-title" id="confirmDeleteUserModalLabel" v-if="selectedIndex < 0">
              {{ $t('modal.confirm_user_delete') }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">
              {{ $t('cancel') }}
            </button>
            <button type="button" class="btn btn-danger" data-dismiss="modal" @click="onDeleteUser">
              {{ $t('confirm') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setTimeout } from 'timers'
import moment from 'moment'
import { sitesMixin, utilsMixin } from '../utils/mixins'

export default {
  name: 'User',
  dependencies: ['adminService', 'loginService'],
  mixins: [utilsMixin, sitesMixin],
  data() {
    return {
      downloaded: false,
      editUserForm: {
        id: 0,
        email: '',
        role: 'admin',
        authType: 'google',
        password: '',
        sites: [],
        confirmPassword: '',
        access_token: '',
        role_id: 0,
      },
      users: [],
      selectedIndex: -1,
      startDate:
        this.$route.params.start != undefined
          ? new Date(this.$route.params.start)
          : moment().subtract(1, 'month'),
      endDate:
        this.$route.params.end != undefined
          ? new Date(this.$route.params.end)
          : moment(new Date(), 'YYYY-MM-DD'),
    }
  },
  mounted() {
    setTimeout(async () => {
      this.fetchUsers()

      await this.$store.dispatch('roles/loadAvailableRoles')
    }, 300)
  },
  components: {
    'page-title': () => import('./utils/PageTitle'),
  },
  computed: {
    availablesRoles: function() {
      return this.$store.getters['roles/availableRoles']
    },
    selectedRole: function() {
      const availableRoles = this.$store.getters['roles/availableRoles']
        ? this.$store.getters['roles/availableRoles']
        : []
      return availableRoles.find(role => role.id === this.editUserForm.role_id)
    },
    sites: function() {
      var filtersConfig = this.$store.getters['config/filtersConfig']
      return filtersConfig.filter_values.site_location
    },
    isFormValid: function() {
      if (
        this.editUserForm.authType == 'custom' &&
        this.editUserForm.role == 'partner' &&
        (String(this.editUserForm.password).trim() == '' ||
          String(this.editUserForm.confirmPassword).trim() == '')
      ) {
        return false
      } else if (
        this.editUserForm.authType == 'custom' &&
        this.editUserForm.password != this.editUserForm.confirmPassword
      ) {
        return false
      } else {
        return true
      }
    },
  },
  methods: {
    fetchUsers: function() {
      this.adminService
        .getAllUsers()
        .then(data => {
          this.users = data.result
          this.downloaded = true
        })
        .catch(e => {
          console.error('Error', e)
        })
    },
    setIndexToDelete: function(index) {
      this.selectedIndex = index
    },
    fillEditModal: function(index) {
      this.selectedIndex = index
      if (index < 0) {
        this.editUserForm = {
          id: 0,
          role: 'partner',
          authType: 'google',
          sites: [],
          password: '',
          confirmPassword: '',
          access_token: '',
          role_id:
            this.availablesRoles && this.availablesRoles.length > 0
              ? this.availablesRoles[0].id
              : 0,
        }
      } else {
        const selectedUser = this.users[index]
        const userSitesID = selectedUser.sites.map(site => {
          return site.site
        })
        this.editUserForm = {
          id: selectedUser.id,
          role: selectedUser.role.toLowerCase(),
          email: selectedUser.email,
          authType: selectedUser.auth_type.toLowerCase(),
          sites: userSitesID,
          password: '',
          confirmPassword: '',
          access_token: '',
          role_id: selectedUser.role_id,
        }
      }
    },
    onDeleteUser: function() {
      var idToDelete = this.users[this.selectedIndex].id
      this.adminService
        .deleteUser(idToDelete)
        .then(() => {
          this.showToast(this.$t('admin.user.delete', [this.users[this.selectedIndex].email]))
          this.users.splice(this.selectedIndex, 1)
        })
        .catch(e => {
          console.error('Error', e)
        })
    },
    onUpdateUser: function() {
      Promise.resolve()
        .then(() => {
          this.editUserForm.access_token = ''
          if (this.editUserForm.id > 0) {
            return this.adminService.updateUser(this.editUserForm)
          } else {
            return this.adminService.createUser(this.editUserForm)
          }
        })
        .then(data => {
          const updatedUser = data.result
          const userToUpdate = {
            id: updatedUser.id,
            email: updatedUser.email,
            role: updatedUser.role,
            role_id: updatedUser.role_id,
            userRole: updatedUser.userRole,
            auth_type: updatedUser.auth_type,
            sites: updatedUser.role === 'admin' ? [] : updatedUser.sites,
          }

          if (this.selectedIndex >= 0) {
            this.$set(this.users, this.selectedIndex, userToUpdate)
            this.showToast(this.$t('admin.user.update', [this.getCurrentUser.email]))
          } else {
            this.$set(this.users, 0, userToUpdate)
            this.showToast(this.$t('admin.user.create', [this.getCurrentUser.email]))
          }
        })
        .catch(e => {
          console.error('Error', e)
        })
    },
    getUserAccessToken: function() {
      this.loginService
        .getUserAccessToken(this.editUserForm.email)
        .then(data => {
          if (data.result.email == this.editUserForm.email) {
            this.editUserForm.access_token = data.result.access_token
          }
        })
        .catch(error => {
          console.error('Error:', error)
        })
    },
  },
}
</script>

<style>
.starter-template {
  padding: 3rem 1.5rem;
  text-align: center;
}

.table > tbody > tr > td {
  vertical-align: middle;
}

.table > tbody > tr > th {
  vertical-align: middle;
}
</style>
